export class DocsAnalyticsVisitData {
    constructor(model) {
        this.versionId = model.versionId;
        this.locale = model.locale || null;
        this.timestamp = new Date(model.timestamp);
        this.visits = model.visits;
        this.sessions = model.sessions;
    }
}
